import { SvgIcon } from "@mui/material";
import styled from "styled-components";

const FramiSvgIcon = styled(SvgIcon)`
    trasform: ${props => props.transform};
`;

export default FramiSvgIcon;
